/**
 * The few ESC/POS commands the tablet sends itself — everything printed on paper comes from the
 * server as bytes (T07-09). Only the drawer kick is local (a cash sale opens the drawer even when
 * the receipt cannot be printed).
 */

/** `ESC p m t1 t2` — pulse pin 2 (drawer 1) for 50 ms on / 500 ms off (Epson/Star/Xprinter). */
export const DRAWER_KICK: Uint8Array = Uint8Array.of(0x1b, 0x70, 0x00, 0x19, 0xfa);

/** `ESC @` — reset the printer (sent before a job on a fresh connection). */
export const INITIALIZE: Uint8Array = Uint8Array.of(0x1b, 0x40);

/** base64 (the server's `receipt.data`) → bytes. */
export function base64ToBytes(data: string): Uint8Array {
  const binary = atob(data);
  const out = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    out[i] = binary.charCodeAt(i);
  }
  return out;
}

export function bytesToBase64(bytes: Uint8Array): string {
  let binary = "";
  for (let i = 0; i < bytes.length; i += 0x8000) {
    binary += String.fromCharCode(...bytes.subarray(i, i + 0x8000));
  }
  return btoa(binary);
}

/** Split for transports with a small packet size (Bluetooth LE ≈ 180 bytes, USB 16 KiB). */
export function chunks(bytes: Uint8Array, size: number): Uint8Array[] {
  if (size <= 0) {
    throw new RangeError("chunk size must be positive");
  }
  const out: Uint8Array[] = [];
  for (let i = 0; i < bytes.length; i += size) {
    out.push(bytes.subarray(i, i + size));
  }
  return out;
}
